import CharacterDetail from 'components/CharacterDetail/CharacterDetailPresentation'

export default CharacterDetail
